<template>
    <div class="checkbox-wrapper">
        <v-expansion-panels v-model="expanded" style="background-color: transparent">
            <v-expansion-panel expand>
                <v-expansion-panel-title class="v-subheader theme--light">
                    {{ $t(`filterTitles.${filter}`) }}
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                    <v-checkbox
                        v-for="(item, index) in partOfValues"
                        :key="`${index}-${item.value}`"
                        v-model="checked"
                        small
                        :hide-details="true"
                        :class="{'pb-3': index + 1 === partOfValues.length}"
                        class="py-0 my-0 full-width"
                        :value="item.value"
                        density="compact"
                        :ripple="!$breakpoint.smAndDown"
                    >
                        <template v-slot:label>
                            <div class="d-flex label-wrapper full-width ms-2">
                                <div class="label-text">
                                    <slot name="label" :value="item.value">
                                        {{ getValue(item) }}
                                    </slot>
                                </div>
                            </div>
                        </template>
                        <template v-slot:append>
                            <div class="ms-auto filter-qty font-weight-bold me-2">
                                {{ `${item.count}` }}
                            </div>
                        </template>
                    </v-checkbox>
                    <v-btn
                        v-if="values.length > showLimit"
                        block
                        size="x-small"
                        variant="text"
                        @click="showAll = !showAll"
                    >
                        {{ showAll ? $t('hide') : $t('show') }} {{ $t('all') }}
                    </v-btn>
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-divider />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Emit} from 'vue-facing-decorator'

    @Component
    export class CheckboxFilter extends Vue {
        @Prop({required: true}) filters
        @Prop({default: false, type: Boolean}) pluralization
        @Prop() filter
        @Prop({default: false, type: Boolean}) translateLabels
        @Prop({default: 0}) panelExpanded
        @Prop({default: false, type: Boolean}) dateFilter
        @Prop({required: true}) filterValues

        showLimit = 6
        showAll = false
        expanded = undefined

        @Emit()
        change(value: number[]) {
            return {key: this.filter, value}
        }

        mounted() {
            this.expanded = this.panelExpanded
        }

        getTranslation(value) {
            return this.pluralization
                ? this.$t(`filters_${this.filter}`, Number(value))
                : this.$t(`filters_${this.filter}.${value}`)
        }

        getValue(item) {
            if (this.dateFilter) {
                return this.$filters.dateFormat(item.value)
            }
            return this.translateLabels || item.value === 'other' ? this.getTranslation(item.value) : item.value
        }

        get checked() {
            return this.filterValues[this.filter]
        }

        set checked(value) {
            this.change(value)
        }

        get values() {
            return this.filters[this.filter]
        }

        get partOfValues() {
            if (!this.showAll && this.values.length > this.showLimit) {
                return this.values.slice(0, this.showLimit)
            }
            return this.values
        }
    }

    export default CheckboxFilter
</script>

<style lang="scss" scoped>
    .label-wrapper {
        width: 100%;
    }

    .label-text {
        font-size: 13px;
    }

    .checkbox-container {
        max-height: 500px;
        overflow: auto;
    }

    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px #ddd;
        border-radius: 10px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #6699cc;
        border-radius: 10px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #b3d4fc;
    }

    :deep(.v-input__append-outer) {
        margin-left: auto;
    }

    .filter-qty {
        color: grey;
        font-size: 10px;
    }

    :deep(.v-expansion-panel-content__wrap) {
        padding: 0;
    }
</style>
